import { useGiftQuery } from '../queries/useGiftQuery';
import { useOrderQuery } from '../queries/useOrderQuery';
import { useOrderBanners } from './useOrderBanners';
import { useOrderIdParam } from './useOrderIdParam';
export const useOrder = () => {
    const { orderId } = useOrderIdParam();
    const { orderQuery } = useOrderQuery([{ orderId }]);
    const { giftQuery } = useGiftQuery([{ giftId: orderQuery.data?.giftId }], {
        enabled: !!orderQuery.data?.giftId,
    });
    const { banners } = useOrderBanners();
    const shippingMethodTooltip = (() => {
        if (orderQuery.data &&
            orderQuery.data.type === 'GIFT' &&
            giftQuery.data &&
            giftQuery.data.giveawayId) {
            return 'Average shipping costs for purchased gifts are included in the product price.';
        }
    })();
    return {
        orderId,
        banners,
        shippingMethodTooltip,
        order: orderQuery.data,
        isLoading: orderQuery.isLoading,
        isUnavailable: orderQuery.isError || (orderQuery.isSuccess && orderQuery.data.status === 'OPEN'),
    };
};
